import React, { useState, useEffect, useRef } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  HistoryOutlined
} from "@ant-design/icons";
import { 
  Button, 
  Divider, 
  Input, 
  Select, 
  Space, 
  Steps, 
  Modal, 
  Table, 
  Tag, 
  Alert,
  Badge
} from "antd";

function User_functionality(props) {
  const [loading, sendRequest] = useAxios();
  const [isError, setisError] = useState(false);
  const [isErrorMessage, setisErrorMessage] = useState();
  const [permission_name, setpermission_name] = useState();
  const [branch, setbranch] = useState();
  const [effective_designation, seteffective_designation] = useState();
  const [functionality, setfunctionality] = useState([]);
  const [functionalitylist, setfunctionalitylist] = useState();

  const [items, setItems] = useState();
  const [filter_permissiondata, setfilter_permissiondata] = useState();
  const [branch_list, setbranch_list] = useState([]);
  const [allbranch_list, setallbranch_list] = useState([]);
  const [
    effective_designation_list,
    seteffective_designation_list,
  ] = useState();
  const [name, setName] = useState("");
  const [entitylist, setentitylist] = useState([
    { ent_id: "E", ent_name: "Effective Designation" },
  ]);
  const [entity, setentity] = useState();
  const [permission_userlist, setpermission_userlist] = useState([]);
  const [permission_user, setpermission_user] = useState([]);
  const permissionRequestId = useRef(0);
  const [functionality_userlist, setfunctionality_userlist] = useState();
  const [view_list, setview_list] = useState();
  const [selected_view, setselected_view] = useState([]);
  const [zonelist, setzonelist] = useState([]);
  const [selectedzone, setselectedzone] = useState();
  const [divisionlist, setdivisionlist] = useState([]);
  const [selecteddivision, setselecteddivision] = useState();
  const [clusterlist, setclusterlist] = useState([]);
  const [geographicalMapping, setGeographicalMapping] = useState([])
  const [selectedcluster, setselectedcluster] = useState();
  const [currentState, setCurrentState] = useState("HO");
  const [savedDivisionOptions, setSavedDivisionOptions] = useState([]);
  
  // New states for assignment results and history
  const [assignmentResult, setAssignmentResult] = useState(null);
  const [showResultModal, setShowResultModal] = useState(false);
  const [assignmentHistory, setAssignmentHistory] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const stages = ["HO", "Zone/State", "Division", "Cluster", "Branch"];
  const currentStageIndex = stages.indexOf(currentState);

  useEffect(() => {
    fetch_permission();
    geteffective_designation();
    getviewlist();
    getheadoffice();
    getallbranch();
    // Load assignment history from localStorage on component mount
    const savedHistory = localStorage.getItem("assignmentHistory");
    if (savedHistory) {
      setAssignmentHistory(JSON.parse(savedHistory));
    }
  }, []);

  // Save assignment history to localStorage whenever it changes
  useEffect(() => {
    if (assignmentHistory.length > 0) {
      localStorage.setItem("assignmentHistory", JSON.stringify(assignmentHistory));
    }
  }, [assignmentHistory]);

  const getallbranch = () => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/data?flag=getallbranches`,
        method: "GET",
        //data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("zone_list", response.data);
        setallbranch_list(response.data);        
      }
    );
  };
  const getcluster = () => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/data?flag=cluster&division_id=[${selecteddivision}]`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("cluster_list", response.data);
        if (response.status !== 0) {
          setGeographicalMapping(response.data.geographical_mapping);
          setbranch_list(response.data.branch_mapping);
          setCurrentState("Cluster");
          setselecteddivision([]);
        } else {
          alert(response.message);
        }
        setbranch();
      }
    );
  };

  const getzone = () => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/data?flag=zone&ho_id=[${selecteddivision}]`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("zone_list", response.data);
        if (response.status !== 0) {
          setGeographicalMapping(response.data.geographical_mapping);
          setbranch_list(response.data.branch_mapping);
          setCurrentState("Zone");
          setselecteddivision([]);
        } else {
          alert(response.message);
        }
        setbranch();
      }
    );
  };

  const getdivision = () => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/data?flag=division&zone_id=[${selecteddivision}]`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("division_list", response.data);
        if (response.status !== 0) {
          setGeographicalMapping(response.data.geographical_mapping);
          setbranch_list(response.data.branch_mapping);
          setCurrentState("Division");
          setselecteddivision([]);
        } else {
          alert(response.message);
        }
        setbranch();
      }
    );
  };
  const getheadoffice = () => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/data?flag=ho`,
        method: "GET",
        //data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("ho_response", response.data.geographical_mapping);
        if (response.status !== 0) {
          setGeographicalMapping(response.data.geographical_mapping);
          setbranch_list(response.data.branch_mapping);
        } else {
          // setdivisionlist([]);
          alert(response.message);
        }
      
        
        setbranch();
      }
    );
  };
  const getviewlist = async () => {
    let apitoken = localStorage.getItem("api_token");
    await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/webhook/configuration/data`,
        method: "GET",
        //data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("view_list", response);
        setview_list(response);
      }
    );
  };
  const geteffective_designation = async () => {
    let apitoken = localStorage.getItem("api_token");
    await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/designation/list`,
        method: "GET",
        //data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("deignations", response);
        seteffective_designation_list(response);
      }
    );
  };
  const fetch_branchlist = async () => {
    let apitoken = localStorage.getItem("api_token");
    await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/data?flag=branch&cluster_id=[${selecteddivision}]`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("branch_list", response.data);
        if (response.status !== 0) {
          setbranch_list([]);
          setbranch_list(response.data.branch_mapping);
          setselecteddivision([]);
        } else {
          alert(response.message);
        }
        setbranch();
      }
    );
  };
  const fetch_permission = async () => {
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "fetch_permission");
    //form.append("role_id", role_functionality_id);
    //form.append("functionality_arr", JSON.stringify(functionality));
    await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("response", response);
        setItems(response.permissions);
      }
    );
  };

  const inputRef = useRef();
  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const addItem = (e) => {
    e.preventDefault();
    const newItem = {
      conditions: [],
      permission_id: "",
      permission_name: name,
    };
    setItems([...items, newItem]);
    setName("");
    setTimeout(() => {
      inputRef.current.focus();
    }, 0);
  };

  const getEffectiveDesignationOrDepartment = (e) => {
    setentity(e);
    let permissionName = permission_name;
    let branchId = branch;
    let type = e;
    // Find the permission by permission_name
    const permission = items.find(
      (item) => item.permission_name === permissionName
    );

    if (!permission) {
      return "Permission not found";
    }

    // Filter the conditions by branch_id
    const conditions = permission.conditions.filter(
      (condition) => condition.branch_id === branchId
    );

    if (conditions.length === 0) {
      return "No conditions found for the given branch_id";
    }

    // Based on type, return effective_designation or department
    console.log("items--", type);
    if (type === "E") {
      const effectiveDesignations = conditions
        .map(
          (condition) =>
            condition.effctive_designation || condition.effective_designation
        )
        .flat()
        .filter(Boolean);
      seteffective_designation(effectiveDesignations);
      
    } else if (type === "D") {
      // Map the department from the filtered conditions
      const departments = conditions
        .map((condition) => condition.department)
        .flat()
        .filter(Boolean);
      return departments.length ? departments : "No departments found";
    } else {
      return "Invalid type";
    }
  };

  const save_functionality = async () => {
    if (!permission_name || !permission_user || permission_user.length === 0) {
      setisError(true);
      setisErrorMessage("Please select permission and at least one user");
      return;
    }
    
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "save_user_functionality");
    form.append(
      "permissions",
      permission_name ? JSON.stringify([permission_name]) : []
    );
    form.append("user_status", "A");
    form.append(
      "functionalities",
      functionality ? JSON.stringify(functionality) : []
    );
    form.append("views", selected_view ? JSON.stringify(selected_view) : []);
    form.append(
      "userid",
      permission_user ? JSON.stringify(permission_user) : []
    );

    try {
      const response = await sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
          method: "POST",
          data: form,
          headers: {
            "api-token": apitoken,
          },
        }
      );

      // Create assignment record
      const assignmentRecord = {
        id: Date.now(),
        functionality: functionality,
        permission: permission_name,
        permissionName: items && items.find(item => item.permission_id === permission_name) ? items.find(item => item.permission_id === permission_name).permission_name : permission_name,
        date: new Date().toISOString(),
        assignedBy: localStorage.getItem("employee_code") || "Admin",
        assignedUsers: response.successful_users || [],
        conflictingUsers: response.conflict_users || [],
        message: response.message || "",
        status: response.status || "partial_success",
        totalSelected: permission_user.length,
        successfullyAssigned: response.successful_users ? response.successful_users.length : 0,
        conflictingCount: response.conflict_users ? response.conflict_users.length : 0
      };

      // Update assignment result state
      setAssignmentResult(assignmentRecord);
      
      // Add to history
      setAssignmentHistory(prev => [assignmentRecord, ...prev]);
      
      // Show result modal
      setShowResultModal(true);
      
      // Reset selections
      setpermission_user([]);
      setfunctionality([]);
      setselected_view([]);

    } catch (error) {
      setisError(true);
      setisErrorMessage(error.message || "An error occurred during assignment");
    }
  };

  const save_permission = async () => {
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "save_permission");
    form.append("permission_name", permission_name);
    form.append(
      "conditions",
      JSON.stringify([
        {
          branch_id: branch,
          status: "A",
          effective_designation: effective_designation,
        },
      ])
    );
    const response = await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setisError(true);
        setisErrorMessage(response.message);
        fetch_permission();
      }
    );
  };
  const get_functionality_data = () => {
    setpermission_name();
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "get_functionality");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        const uniqueElements = response.functionality.reduce((acc, current) => {
          const x = acc.find(
            (item) => item.function_name === current.function_name
          );
          if (!x && current.function_name) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, []);
        console.log("get_functionality_data", uniqueElements);
        setfunctionalitylist(uniqueElements);
      }
    );
  };
  const get_permissiondata = (e) => {
    setpermission_name(e);
    const filteredPermissions = items.filter(
      (permission) => permission.permission_name === e
    );
    console.log("filteredPermissions", filteredPermissions);
    setfilter_permissiondata(filteredPermissions);
  };

  const get_branch_name = (branch_id) => {
    const branch = allbranch_list.find((branch) => branch.branch_id === branch_id);
    return branch ? branch.branch_name : "Branch not found";
  };

  const get_effectivedesi_name = (ids) => {
    console.log("names->", ids);
    if (!Array.isArray(ids)) {
      return "";
    }

    const names = ids.map((id) => {
      const effectivedesi = effective_designation_list.find(
        (effectivedesi) => effectivedesi.effective_designation_id === id
      );
      return effectivedesi ? effectivedesi.designation_name : "";
    });
    return names.filter((name) => name !== "").join(", ");
  };

  const handleFetchMapping = () => {
    // setbranch_list([])
    if (selecteddivision && selecteddivision.length > 0) {
      const selectedOptions = (geographicalMapping || [])
        .filter(item => selecteddivision.includes(item[Object.keys(item)[0]]))
        .map(item => {
          const keys = Object.keys(item);
          return {
            value: item[keys[0]],
            label: item[keys[1]],
          };
        });
      setSavedDivisionOptions(prev => [...prev, ...selectedOptions]);
    }

    if (selecteddivision.length>0 && currentState==='HO' ){
      getzone();
    }
    if (selecteddivision.length>0 && currentState==='Zone' ){
      getdivision();
    }
    if (selecteddivision.length>0 && currentState==='Division' ){
      getcluster();
    }
    if (selecteddivision.length>0 && currentState==='Cluster'){
      fetch_branchlist();
    }
    
  }

  const get_permission_user = (e) => {
    const requestId = ++permissionRequestId.current;
    setpermission_name(e);
    setpermission_user([]);
    setpermission_userlist([]);
    setfunctionality([]);
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "get_all_users_for_permission");
    form.append("permission_id", e);
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        if (requestId === permissionRequestId.current) {
        console.log("get_permission_user", response);
        setpermission_userlist(Array.isArray(response.users) ? response.users : []);
        }
      }
    );

    const form1 = new FormData();
    form1.append("flag", "fetch_permission_user_functionality");
    form1.append("permission_id", e);
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form1,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        const userFunctionalityMap = response.puf_mapping.flatMap((puf) =>
          puf.user_functionality.map((userFunc) => ({
            userid: userFunc.userid,
            functionalitys: userFunc.functionalitys,
          }))
        );

        setfunctionality_userlist(userFunctionalityMap);
      }
    );
  };
  useEffect(() => {
    const matchedFunctionalities =
      functionality_userlist &&
      functionality_userlist
        .filter(
          (userFunc) =>
            permission_user && permission_user.includes(userFunc.userid)
        )
        .flatMap((userFunc) => userFunc.functionalitys);

    console.log("matchedFunctionalities", matchedFunctionalities);
    setfunctionality(matchedFunctionalities);
  }, [permission_user]);
  console.log("items", permission_user);

  const divisionOptions = savedDivisionOptions.map(item => ({
    label: item.label,
    value: item.value,
  }));

  const branchOptions = (branch_list || []).map(item => {
    const keys = Object.keys(item);
    return {
      label: item[keys[1]],
      value: item[keys[0]],
    };
  });

  // Function to get user display name
  const getUserDisplayName = (userId) => {
    if (!permission_userlist) return userId;
    const user = permission_userlist.find(u => u.userid === userId);
    return user ? `${user.employee_code} - ${user.designation_name}` : userId;
  };

  // Function to get functionality name
  const getFunctionalityName = (id) => {
    if (!functionalitylist) return id;
    const func = functionalitylist.find(f => f.functionality_id === id);
    return func ? func.function_name : id;
  };

  // Function to get permission name by ID
  const getPermissionName = (id) => {
    if (!items) return id;
    const perm = items.find(p => p.permission_id === id);
    return perm ? perm.permission_name : id;
  };

  // Function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  // Render assignment history modal
  const renderHistoryModal = () => {
    const columns = [
      {
        title: 'Date & Time',
        dataIndex: 'date',
        key: 'date',
        render: (date) => formatDate(date),
        sorter: (a, b) => new Date(a.date) - new Date(b.date),
        defaultSortOrder: 'descend',
      },
      {
        title: 'Permission',
        dataIndex: 'permissionName',
        key: 'permissionName',
      },
      {
        title: 'Functionalities',
        dataIndex: 'functionality',
        key: 'functionality',
        render: (funcs) => funcs ? funcs.map(f => getFunctionalityName(f)).join(', ') : 'N/A',
      },
      {
        title: 'Assigned By',
        dataIndex: 'assignedBy',
        key: 'assignedBy',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status) => {
          let color = 'default';
          let text = 'Unknown';
          
          if (status === 'partial_success') {
            color = 'orange';
            text = 'Partial Success';
          } else if (status === 'success') {
            color = 'green';
            text = 'Success';
          } else if (status === 'error') {
            color = 'red';
            text = 'Failed';
          }
          
          return <span className={`badge badge-${color}`}>{text}</span>;
        },
      },
      {
        title: 'Success/Conflict',
        key: 'stats',
        // Apply custom CSS only to this column
      headerStyle: { 
        padding: '5px 0px',
        textAlign: 'center'
      },
        render: (_, record) => (
          <div>
            <span className="badge badge-success mr-1">{record.successfullyAssigned || 0} Success</span>
            <span className="badge badge-danger">{record.conflictingCount || 0} Conflict</span>
          </div>
        ),
      },
      {
        title: 'Actions',
        key: 'actions',
        render: (_, record) => (
          <Button 
            type="link" 
            onClick={() => {
              setAssignmentResult(record);
              setShowResultModal(true);
              setShowHistoryModal(false);
            }}
          >
            View Details
          </Button>
        ),
      },
    ];

    return (
      <Modal
        title="Permission Assignment History"
        visible={showHistoryModal}
        onCancel={() => setShowHistoryModal(false)}
        footer={[
          <Button key="close" onClick={() => setShowHistoryModal(false)}>
            Close
          </Button>
        ]}
        width={1000}
      >
        <Table
          columns={columns}
          dataSource={assignmentHistory}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </Modal>
    );
  };

  // Assignment Result Modal content
  const renderAssignmentResultModal = () => {
    if (!assignmentResult) return null;

    const successCount = assignmentResult.successfullyAssigned || 0;
    const conflictCount = assignmentResult.conflictingCount || 0;

    return (
      <Modal
        title="Assignment Result"
        visible={showResultModal}
        onCancel={() => setShowResultModal(false)}
        footer={[
          <Button key="close" onClick={() => setShowResultModal(false)}>
            Close
          </Button>,
          <Button 
            key="history" 
            type="primary" 
            onClick={() => {
              setShowResultModal(false);
              setShowHistoryModal(true);
            }}
          >
            View History
          </Button>
        ]}
        width={800}
      >
        <Alert
          message={assignmentResult.message}
          type={assignmentResult.status === 'partial_success' ? 'warning' : 'success'}
          showIcon
          style={{ marginBottom: 20 }}
        />
        
        <h6
          className="p-2 bg-success text-white"
          style={{ borderRadius: "5px" }}
        >
          Successfully Assigned Users ({successCount})
        </h6>
        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
          {assignmentResult.assignedUsers && assignmentResult.assignedUsers.map((u, i) => (
            <span key={i} className="badge badge-success m-1">
              {u}
            </span>
          ))}
        </div>

        <h6
          className="p-2 bg-danger text-white mt-3"
          style={{ borderRadius: "5px" }}
        >
          Conflicting Users ({conflictCount})
        </h6>
        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
          {assignmentResult.conflictingUsers && assignmentResult.conflictingUsers.map((user, i) => (
            <div key={i} className="mb-2">
              <span className="badge badge-danger m-1">{user.username}</span>
              <div style={{ fontSize: "12px", color: "#f5222d" }}>
                {user.message}
              </div>
            </div>
          ))}
        </div>
      </Modal>
    );
  };

  return (
    <div className="container">
      <Commonheader pagetitle={"Permission"} props={props} />
      {loading && (
        <div className="load-4">
          <div className="ring-1"></div>
        </div>
      )}
      <div
        className={
          isError
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisError(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="popuperrtext">{isErrorMessage}</p>
          </div>
        </div>
      </div>

      {/* Assignment Result Modal */}
      {renderAssignmentResultModal()}

      {/* Assignment History Modal */}
      {renderHistoryModal()}

      <div className="mt-4">
        <div id="accordion">
          <div className="card">
            <div className="card-header" id="headingOne">
              <h5 className="mb-0">
                <button
                  className="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  Permission
                </button>
              </h5>
            </div>

            <div
              id="collapseOne"
              className="collapse"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div className="card-body">
                <Steps current={currentStageIndex} style={{ marginBottom: 12 }}>
                  {stages.map((stage) => (
                    <Steps.Step key={stage} title={stage} />
                  ))}
                </Steps>
                <div className="row">
                  <div className="col-md-3 mt-1">
                    <Select
                      className="form-control"
                      placeholder="Select Permission"
                      onChange={(e) => get_permissiondata(e)}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider style={{ margin: "8px 0" }} />
                          <Space style={{ padding: "0 8px 4px" }}>
                            <Input
                              placeholder="Enter Permission Name"
                              ref={inputRef}
                              value={name}
                              onChange={onNameChange}
                              onKeyDown={(e) => e.stopPropagation()}
                            />
                            <Button
                              disabled={!name}
                              type="text"
                              icon={<PlusOutlined />}
                              onClick={addItem}
                            ></Button>
                          </Space>
                        </>
                      )}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={
                        items &&
                        items.map((item) => ({
                          label: item.permission_name,
                          value: item.permission_name,
                        }))
                      }
                    />
                  </div>
                  <div className="col-md-3 mt-1">
                    <Select
                      mode="tags"
                      className="form-control"
                      value={selecteddivision}                      
                      tokenSeparators={[","]}
                      onChange={(value) => {
                        if (value.includes("all")) {
                          const allBranchIds =
                            geographicalMapping
                            &&
                            geographicalMapping.map((item) => {
                              const keys = Object.keys(item);
                              return item[keys[0]];
                            });
                          setselecteddivision(allBranchIds);
                        } else {
                          const selectedValues = value
                            .map((val) => {
                              if (typeof val === "string") {
                                const foundOption = geographicalMapping.find(
                                  (item) =>{
                                    const keys = Object.keys(item);
                                    return item[keys[1]].toLowerCase() ===
                                    val.toLowerCase();

                                  }
                                );
                                return foundOption
                                  ? (() => {
                                      const keys = Object.keys(foundOption);
                                      return foundOption[keys[0]]; 
                                    })()
                                  : null;
                              }
                              return val; // If `val` is not a string, return it as is
                            })
                            .filter((val) => val !== null);
                            console.log("selected values ... ",selectedValues);
                          setselecteddivision(selectedValues);
                        }
                      }}
                      placeholder="Select Division"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={[
                        {
                          label: "- All -",
                          value: "all",
                        },
                        ...(geographicalMapping
                          ? geographicalMapping.map((item) => {
                              const keys = Object.keys(item);
                              return{
                                label: item[keys[1]],
                                value: item[keys[0]]
                              };
                            })
                          : []),
                      ]}
                    />
                  </div>
                  <div className="col-md-3 mt-1">
                    <Select
                      mode="tags"
                      className="form-control"
                      value={branch}
                      disabled={branchOptions.length === 0 && divisionOptions.length === 0}
                      tokenSeparators={[","]}
                      onChange={(value) => {
                        if (value.includes("all")) {
                          const allBranchIds =
                            branch_list &&
                            branch_list.map((item) => {
                              const keys = Object.keys(item);
                              return item[keys[0]];
                            });
                          const allDivisionIds = divisionOptions.map((item) => item.value);
                          setbranch([...allDivisionIds, ...allBranchIds]);
                        } else {
                          const selectedValues = value
                            .map((val) => {
                              if (typeof val === "string") {
                                const foundDivision = divisionOptions.find(
                                  (item) => item.label.toLowerCase() === val.toLowerCase()
                                );
                                if (foundDivision) return foundDivision.value;
                      
                                const foundOption = branch_list.find(
                                  (item) =>
                                    {
                                      const keys = Object.keys(item);
                                      return item[keys[1]].toLowerCase() ===
                                      val.toLowerCase();
  
                                    }
                                );
                                return foundOption
                                  ? (() => {
                                      const keys = Object.keys(foundOption);
                                      return foundOption[keys[0]]; 
                                    })()
                                  : null;
                              }
                              return val; // If `val` is not a string, return it as is
                            })
                            .filter((val) => val !== null);
                            console.log("selected values ... ",selectedValues);
                          setbranch(selectedValues);
                        }
                      }}
                      placeholder="Select Branch"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={[
                        {
                          label: "- All -",
                          value: "all",
                        },
                        {
                          label: "Virtual Entities",
                          options: divisionOptions,
                        },
                        {
                          label: "Branches",
                          options: branchOptions,
                        },
                      ]}
                    />
                  </div>
                  <div>
                    <Button type="primary" onClick={handleFetchMapping} ghost>fetch mapping</Button>
                  </div>
                  <div className="col-md-3 mt-1">
                    <Select
                      className="form-control"
                      placeholder="Select Entity"
                      onChange={(e) => {
                        getEffectiveDesignationOrDepartment(e);
                      }}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={
                        entitylist &&
                        entitylist.map((item) => ({
                          label: item.ent_name,
                          value: item.ent_id,
                        }))
                      }
                    />
                  </div>
                  {entity === "E" && (
                    <div className="col-md-3 mt-1">
                      <Select
                        mode="tags"
                        className="form-control"
                        value={effective_designation}
                        tokenSeparators={[","]}
                        onChange={(value) => {
                          if (value.includes("all")) {
                            const allBranchIds =
                              effective_designation_list &&
                              effective_designation_list.map(
                                (item) => item.effective_designation_id
                              );
                              seteffective_designation(allBranchIds);
                          } else {
                            const selectedValues = value
                              .map((val) => {
                                if (typeof val === "string") {
                                  const foundOption = effective_designation_list.find(
                                    (item) =>
                                      item.designation_name +
                                        " - " +
                                        item.designation_code.toLowerCase() ===
                                      val.toLowerCase()
                                  );
                                  return foundOption
                                    ? foundOption.effective_designation_id
                                    : null;
                                }
                                return val; // If `val` is not a string, return it as is
                              })
                              .filter((val) => val !== null);
                              seteffective_designation(selectedValues);
                          }
                        }}
                        placeholder="Select Effective Designation"
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option && option.label
                            ? option.label.toLowerCase()
                            : ""
                          ).includes(input.toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA && optionA.label
                            ? optionA.label.toLowerCase()
                            : ""
                          ).localeCompare(
                            optionB && optionB.label
                              ? optionB.label.toLowerCase()
                              : ""
                          )
                        }
                        options={[
                          {
                            label: "- All -",
                            value: "all",
                          },
                          ...(effective_designation_list
                            ? effective_designation_list.map((item) => ({
                                label:
                                  item.designation_name +
                                  " - " +
                                  item.designation_code,
                                value: item.effective_designation_id,
                              }))
                            : []),
                        ]}
                      />
                    </div>
                  )}
                  <div className="col-md-2 mt-1">
                    <button
                      className="btn btn-primary form-control"
                      onClick={() => save_permission()}
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className="mt-4">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Branch Name</th>
                        <th>Status</th>
                        <th>Effective Designation</th>
                        {/* <th>Department</th>
                        <th>User ID</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {filter_permissiondata &&
                        filter_permissiondata[0].conditions.map(
                          (condition, index) => (
                            <tr key={`${index}`}>
                              <td>{index + 1}</td>
                              <td>{get_branch_name(condition.branch_id)}</td>
                              <td>{condition.status}</td>
                              <td>
                                {condition.effective_designation &&
                                  get_effectivedesi_name(
                                    condition.effective_designation
                                  )}
                              </td>
                              {/* <td>
                              {condition.department
                                ? condition.department.join(", ")
                                : "N/A"}
                            </td>
                            <td>
                              {condition.userid
                                ? condition.userid.join(", ")
                                : "N/A"}
                            </td> */}
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                </div>
                <div className="mt-4">
                  
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <button
                  className="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                  onClick={() => get_functionality_data()}
                >
                  User Functionality
                </button>
              </h5>
            </div>
            <div
              id="collapseTwo"
              className="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="row">
                  <div className="col-md-3 mt-1">
                    <Select
                      className="form-control"
                      placeholder="Select Permission"
                      onChange={(e) => get_permission_user(e)}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={
                        items &&
                        items.map((item) => ({
                          label: item.permission_name,
                          value: item.permission_id,
                        }))
                      }
                    />
                  </div>
                  <div className="col-md-3 mt-1">
                    <Select
                      className="form-control"
                      mode="tags"
                      tokenSeparators={[","]}
                      placeholder="Select User"
                      value={permission_user}
                      onChange={(value) => {
                        if (value.includes("all")) {
                          const allUserIds =
                            permission_userlist &&
                            permission_userlist.map((item) => item.userid);
                          setpermission_user(allUserIds || []);
                        } else {
                          const selectedValues = value
                            .map((val) => {
                              if (typeof val === "string") {
                                const foundOption =
                                  permission_userlist &&
                                  permission_userlist.find(
                                    (item) =>
                                      item.employee_code.toLowerCase() ===
                                      val.toLowerCase()
                                  );
                                return foundOption ? foundOption.userid : null;
                              }
                              return val; // If `val` is not a string, return it as is
                            })
                            .filter((val) => val !== null);
                          setpermission_user(selectedValues);
                        }
                      }}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={[
                        {
                          label: "- All -",
                          value: "all",
                        },
                        ...(permission_userlist
                          ? permission_userlist.map((item) => ({
                              label: `${item.employee_code} - ${item.designation_name}`,
                              value: item.userid,
                            }))
                          : []),
                      ]}
                    />
                  </div>
                  <div className="col-md-3 mt-1">
                    <Select
                      className="form-control"
                      mode="multiple"
                      placeholder="Select Functionality"
                      value={functionality}
                      onChange={(e) => setfunctionality(e)}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={
                        functionalitylist &&
                        functionalitylist.map((item) => ({
                          label: item.function_name,
                          value: item.functionality_id,
                        }))
                      }
                    />
                  </div>
                  <div className="col-md-3 mt-1">
                    <Select
                      className="form-control"
                      mode="multiple"
                      placeholder="Select View"
                      value={selected_view}
                      onChange={(e) => setselected_view(e)}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={
                        view_list &&
                        view_list.map((item) => ({
                          label: item.view_name,
                          value: item.view_id,
                        }))
                      }
                    />
                  </div>
                  <div className="col-md-2 mt-2">
                    <button
                      className="btn btn-primary form-control"
                      onClick={() => save_functionality()}
                    >
                      Save
                    </button>
                  </div>
                </div> 
                {/* Show selected users count */}
                {permission_user && permission_user.length > 0 && (
                  <Alert
                    message={`${permission_user.length} user(s) selected for assignment`}
                    type="info"
                    showIcon
                    style={{ marginTop: '10px' }}
                  />
                )}
                
                {/* History Button */}
                <div className="mt-3">
                  <Button 
                    type="primary" 
                    icon={<HistoryOutlined />}
                    onClick={() => setShowHistoryModal(true)}
                  >
                    View Assignment History
                    {assignmentHistory.length > 0 && (
                      <Badge 
                        count={assignmentHistory.length} 
                        style={{ marginLeft: '10px', backgroundColor: '#1890ff' }}
                      />
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default User_functionality;
